import TaxIndex from './TaxIndex.vue';

export default TaxIndex;
